// extracted by css-extract-rspack-plugin
export default {"layout":"eYteD","header":"WaILK","main":"q7cJv","sidebar":"mk1fb","footer":"q8bhd"};